export default __webpack_public_path__ + "static/media/advantage1.23dc9509.svg";